import Loadable from "app/components/Loadable";
import { lazy } from "react";

const LitterConditionList = Loadable(lazy(() => import("./LitterConditionList")));
const LitterConditionForm = Loadable(lazy(() => import("./LitterConditionForm")));

const litterConditionRoutes = [
  {
    path: "/LitterCondition/LitterConditionList",
    element: <LitterConditionList />,
  },
  {
    path: "/LitterCondition/LitterConditionForm",
    element: <LitterConditionForm />,
  },
  {
    path: "/LitterCondition/LitterConditionForm/:litterConditionId",
    element: <LitterConditionForm />,
  },
];

export default litterConditionRoutes;
